<template>
            <el-row :gutter="0" class="forms" id="form" >
                <el-col :md="24" :xs="22" class="xs mt12 pt12 el-col-xs-offset-1" >
                    <p>¿Conoces a alguien con Alfa-Manosidosis? </p>
                </el-col>
                <el-col :md="24" :xs="20" class="xs12 my12 el-col-xs-offset-2">
                    <p class="texto">
                        Creemos firmemente que podemos contribuir a la calidad de vida de todas las 
                        personas con <br> Alfa-Manosidosis
                    </p>
                </el-col>
                <el-col :md="24" :xs="20" class="xs12  el-col-xs-offset-2">
                    <p class="texto1">
                        Déjanos tus datos y nos pondremos en contacto
                    </p>
                </el-col>
                <el-col :md="22" :xs="24" class="el-col-md-offset-1 el-col-xs-offset-0"> 
                    <el-form ref="ruleForm" 
                    :model="ruleForm"
                    id="send"
                    :rules="rules"
                    @submit.prevent="submitForm" :inline="true">
                    <el-row class="data1">
                        <el-col :md="10" :sm="20" :xs="24" 
                        class="el-col-md-offset-0 el-col-sm-offset-2 el-col-xs-offset-0" >
                            <el-form-item prop="name"  required>
                                <el-input 
                                class="in"
                                v-model.string="ruleForm.name"
                                placeholder="Nombre"
                                name="name"
                                @keydown="onKeydown"
                              >
                             </el-input>
                            </el-form-item>
                        </el-col>
                        
                        <el-col :md="12" :sm="20" :xs="24"
                        class="el-col-md-offset-0 el-col-sm-offset-2 el-col-xs-offset-0">
                        <el-form-item prop="last" required >
                            <el-input
                                class="in"
                                @keydown="onKeydown"
                                v-model.number="ruleForm.last"
                                placeholder="Apellidos"
                                name="last">
                         </el-input>
                        </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="data1">
                        <el-col :md="10" :sm="20" :xs="24"
                        class="el-col-md-offset-0 el-col-sm-offset-2 el-col-xs-offset-0">
                            <el-form-item prop="email" required>
                                <el-input 
                            type="email"
                            class="in"
                            v-model="ruleForm.email"
                            placeholder="Correo electrónico"
                            name="email">
                            </el-input>
                            </el-form-item>
                        </el-col>
                    <el-col :md="12" :sm="20" :xs="24" 
                    class="el-col-md-offset-0 el-col-sm-offset-2 el-col-xs-offset-0">
                    <el-form-item prop="phone" required>
                        <el-input
                        type="tel"
                        class="in"
                        v-model="ruleForm.phone"
                        placeholder="Teléfono"
                        @keydown="onKey"
                        name="phone">
                        </el-input>
                    </el-form-item>

                    
                    </el-col>
                    </el-row>
                    <el-row style="data2">
                        <el-col :md="22" :xs="24" >    
                            <el-form-item prop="type"   required>
                            <el-radio-group v-model="ruleForm.type" name="type" class="notu">
                            <el-radio class="chequer"
                             label="Soy paciente o cuidador"
                             name="type"
                            default
                             >
                                </el-radio>
                             
                            <el-radio @click="showP = !showP" name="type" label="Soy médico"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                        
                        </el-col>   
                    </el-row>
                    <el-row>
                        <el-col :md="24">
                            <input class="envio"
                             type="submit" value="Enviar" @click="submitForm('ruleForm', $event)">
 
                        </el-col>
                    </el-row>
                </el-form>
                </el-col>
            </el-row>
        <el-row >
            <el-col :lg="24" :xs="22" class="xs12 footer py12 el-col-xs-offset-1" id="footer">
                <h6 v-if="!showMaterial" @click="modal">Soy profesional de la salud</h6>
                <h6 v-else @click="modal">Soy paciente</h6>
                <br>
                <div class="really">
                    <p @click="contenido('aviso')">Aviso de privacidad </p>   
                    <p @click="contenido('terminos')" class="spacer">Términos y condiciones</p>
                </div>
                <p class="notreally"><span @click="contenido('aviso')" >Aviso de privacidad </span> - <br class="hidden-sm-and-up"> <span @click="contenido('terminos')" class="spacer"> Términos y condiciones</span></p>
            </el-col>
        </el-row>
        <TyC v-if="showTyC" :aviso="valuess" />
        <Modal v-if="showOverlay" />
</template>
<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

import { ElMessageBox } from 'element-plus';
import TyC from "@/components/home/TyC.vue"
import Modal from '@/components/home/modal.vue'

import emailjs from 'emailjs-com'
export default {
    components:{
    TyC,
    Modal
    },
    data(){
        
        return{   
        ruleForm:{
            name: '',
            last: '',
            email: '',
            phone: '',
            type:''
        },
        rules:{
             name: [
            { required: true, message: 'Porfavor ingresa tu nombre', trigger: 'blur' },
            { min: 3, max: 20, message: 'Debe ser de almenos 3 letras sin numeros', trigger: 'blur' },
            ],
           last: [
            { required: true, message: 'Porfavor ingresa tus apellidos', trigger: 'blur' },
            { min: 3, max: 50, message: 'Debe ser de almenos 3 letras sin numeros', trigger: 'blur' }
          ],
            email: [
            { required: true, message: 'Porfavor ingresa tu correo', trigger: 'blur',},
            { min: 3, max: 40, message: 'Debe de ser entre 5 y 40 carácteres', trigger: 'blur' },
            { type:'email', message:'Ingreasa el formato correcto de tu correo', trigger: 'blur'}
          ],
          phone: [
            { required: true, message: 'Porfavor ingresa tu número', trigger: 'blur' },
            ],
           type: [
            { required: true, message: 'Porfavor ingresa tu estátus', trigger: 'blur' },
            ],
        }
        }
    },
    methods:{
        submitForm(formName) {
            console.log(formName)
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            this.sendEmail(formName);
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    
      sendEmail: (e) => {
          console.log(e)
      emailjs.sendForm('service_wg3w4s9', 'template_0y9mf5q', e.target,
        'user_Kr5evzJh8fCcHR0j0mmEG').then((result) => {
            ElMessageBox('Mensaje enviado exitosamente');
            console.log('SUCCESS!', result.status, result.text);
            }, (error) => {
            console.log('FAILED...', error);
        });
    },
    onKeydown: (e) =>{
        const char = String.fromCharCode(e.keyCode)
        const regex = new RegExp(/^[0-9]/)
        if(regex.test(char)){
            e.preventDefault()
            console.log(e)
        }
    },
    onKey: (e) =>{
        const char = String.fromCharCode(e.keyCode)
        const regex = new RegExp(/^[a-zA-Z]/)
        if(regex.test(char)){
            e.preventDefault()
            console.log(e)
        }
    }
    }
    ,
    setup() {
        const store = useStore()
        const showTyC = computed(() => store.state.showTyC)
        const showMaterial = computed(() => store.state.showMaterial)   
        const mater =() => store.commit('mater')
        
        const showP= ref(false);
        const valuess = ref('')
        
        const modal = () =>{
         if(showMaterial.value === true){
            mater()
            window.scrollTo({top:0, behavior:'smooth'}) 

        }else{
            store.commit('modal')
        }
        }
        const contenido = (varial) =>{
            store.commit("tyc")
            valuess.value= varial
        }

        return { showP,
         showTyC,
         valuess,
         contenido,
         showMaterial,
         mater,
         modal }
    },
}
</script>
<style lang="scss" scoped>
    
    .xs p{
        font-family: 'Yusei-Magic';
        font-size: 48px;
        color: #fff;
    }
    .xs12 .texto{ 
        font-family: 'Avenir-light';
        font-size: 22px;
        color: #fff;
        font-weight: 100;
        line-height: 30px;
    }
    
    .xs12 .texto1{ 
        font-family: 'Avenir-light';
        font-size: 22px;
        color: #fff;
        font-weight: 00;
        line-height: 30px;
    }
    .data1{
        margin-top: 30px;
    }
    .data2{
        margin-top: 50px;
    }
    .chequer .el-radio__inner{
     visibility: hidden !important;
    }
    
.el-input__inner {
  font-family: 'Avenir-light' !important;
  color: #ffffff !important;
  background-color: transparent !important;
  border: 2px solid #fff !important;
  height: 58px !important;
  width: 100%;
  padding-left: 15px;
  border-radius: 20px !important;
}
    .w-divider{
        border: 2px solid #fff ;
        margin: auto;
        margin-top: 15px;
        width: 250px;
    }
    label{
        color: #fff;
        font-size: 25px;
    }
    .envio{
        margin-top: 30px;
        font-family: 'Avenir';
        width: 332px;
        height: 50px;
        border: none;
        font-size: 22px !important;
        font-weight: 800;
        border-radius: 20px;
        margin-bottom: 50px;
        color: #000D5A;
        background-color:#fff;
        box-shadow: 0px 2px 20px rgba(255, 255, 255, 0.51);
    }
    .footer h6{
        font-family: 'Avenir';
        font-size: 16px;
        font-weight: 800;
        color:#000D5A;
        margin: 0;
        margin-top:30px;
    }
    .forms .el-radio__input{
        visibility: hidden !important;
    }
    .footer p{
        font-family: 'Avenir';
        font-size: 16px  !important;
        color: #000;
        cursor: pointer;
    }
    .really{
        display: none;
    }
    @media(max-width:1400px){
        .xs p{
            margin-top:80px;
            margin-bottom:10px
        }
        .data1{
            margin-top:5px
        }
        
    }
    @media (max-width:1024px) {
         .data1{
            width: 115%;
        }
        .data1 .el-col-md-12{
            flex: 0 0  50%;
        }
        
        .data1 .el-col-md-10{
            flex: 0 0  50%;
        }
    }
    @media (max-width:768px) {
        .xs12{
            margin-top: 50px;
        }
       
        .really{
            display: block;
        }
        .notreally{
            display: none;
        }
        .data1{
            width: 100%;
        }
        
        .data1 .el-col-md-10{
            flex: 0 0  100%;
        }
        .data1 .el-col-md-12 {
            flex: 0 0 100%;
        }
    }
    @media (max-width:500px) {
        .xs p{
            font-size: 35px;
        }
        .texto{
            font-size: 41px;
        }
        .check{
            margin-top: 15px;
        }
        .xs12{
            margin-top:10px;
        }
        .xs{
            margin-top: 50px;
        }
        .data1{
             margin-top: 10px;
        }
        
        .data2{
            margin-top: 20px;
        }
        .spacer{
            margin-top: 15px;
        }
        .footer p{
            line-height: 2.5;
        }
    }
</style>